var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPath6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 350,
    height: 183,
    viewBox: "0 0 350 183",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.8;fill:url(#a);}.b,.c{stroke:none;}.c{fill:#5b2a6a;}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 0.188,
    cy: 0.15,
    r: 1.087,
    gradientTransform: "matrix(0.496, 0.868, -0.552, 0.315, 0.177, -0.06)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6a3889",
    stopOpacity: 0.376
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#650f69",
    stopOpacity: 0.373
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M 309.344482421875 181.5 L 27.70450019836426 181.5 C 13.25527286529541 181.5 1.5 171.7813110351562 1.5 159.83544921875 L 1.5 35.17778015136719 L 41.73138046264648 1.5 L 322.2955017089844 1.5 C 336.7447204589844 1.5 348.5 11.21868228912354 348.5 23.1645450592041 L 348.5 147.0771789550781 L 309.344482421875 181.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M 42.27639770507812 3 L 3 35.87837219238281 L 3 159.83544921875 C 3 170.9542236328125 14.0823974609375 180 27.70449829101562 180 L 308.7789306640625 180 L 347 146.3986663818359 L 347 23.16455078125 C 347 12.0457763671875 335.9176025390625 3 322.2955017089844 3 L 42.27639770507812 3 M 41.18646240234375 0 L 322.2955017089844 0 C 337.5962829589844 0 350 10.37113952636719 350 23.16455078125 L 350 147.7557220458984 L 309.9100952148438 183 L 27.70449829101562 183 C 12.40371704101562 183 0 172.6288604736328 0 159.83544921875 L 0 34.47727966308594 L 41.18646240234375 0 Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath6);
export default __webpack_public_path__ + "static/media/Path 6.6e4f08c0b908818cae53f83296390e45.svg";
export { ForwardRef as ReactComponent };